import React from "react";
import AotdGeneratingPanel from "../AotdGeneratingPanel";
import AotdCardsReadyButton from "../../../respectCards/aotd/AotdCardsReadyButton";
import { useLoadingMessages } from "../../hooks/useLoadingMessages";
import type { EmojiPenaltyResponse, WaitingRoomRacer } from "../../api/types";

export interface GeneratingStateProps {
  phase?: string;
  participantCount?: number;
  participantEmojis?: string[];
  racers?: WaitingRoomRacer[];
  message?: string;
  generationStatus?: string;
  stepLabel?: string;
  stepName?: string;
  stepIndex?: number;
  totalSteps?: number;
  percent?: number;
  /** Time spent INSIDE the current step at the latest WS step event (live feed only). */
  stepElapsedMs?: number;
  previewB64?: string;
  previewIndex?: number;
  emojiPenalty?: EmojiPenaltyResponse;
}

export const GeneratingState: React.FC<GeneratingStateProps> = ({
  phase,
  participantCount,
  participantEmojis,
  racers,
  message,
  generationStatus,
  stepLabel,
  stepName,
  stepIndex,
  totalSteps,
  percent,
  stepElapsedMs,
  previewB64,
  previewIndex,
  emojiPenalty,
}) => {
  const isActiveGeneration = ["generating", "busy", "resuming"].includes(generationStatus ?? "");
  // The flavour line is tertiary — the fine-grained sub-status (stepLabel) and
  // the coarse phase badge already convey *what* is happening. So while we're
  // actively generating we cycle through the fun LOADING_MESSAGES to keep the
  // wait lively; the coarse `message` (phase text) would otherwise freeze this
  // slot and duplicate the step label. `message` is still used verbatim for
  // non-active generating screens (e.g. race_lost: "X entered 50ms before you").
  const loadingMessage = useLoadingMessages(isActiveGeneration);
  const flavourMessage = isActiveGeneration ? loadingMessage : message;

  return (
    <>
      <AotdGeneratingPanel
        generationStatus={generationStatus}
        phase={phase}
        participantCount={participantCount}
        participantEmojis={participantEmojis}
        racers={racers}
        message={flavourMessage}
        stepLabel={stepLabel}
        stepName={stepName}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        percent={percent}
        stepElapsedMs={stepElapsedMs}
        previewB64={previewB64}
        previewIndex={previewIndex}
        emojiPenalty={emojiPenalty}
      />
      <AotdCardsReadyButton />
    </>
  );
};

export default GeneratingState;
